<template>
  <b-container
    fluid="md"
    class="square-payment-payment-transaction-status-error"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="triangle-exclamation"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            Transaction state invalid
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-type">
          <p>Current status/state of transaction to be paid is not valid for payment.</p>
          <p>This usually occurs when the transation has already been paid, cancelled or refunded.</p>
          <p>Please contact the site administrator for assist resolving this issue.</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'square-payment-transaction-status-error',
  props: {
    error: {
      type: [Error, Object],
      required: true
    }
  }
}
</script>

<style>

</style>
